import { h } from 'preact'
import styles from './MatchStatus.module.css'
import { IMatchData } from '../../lib/model'
import { useCustomContext } from '../../lib/context'

interface Props {
  matchData: IMatchData
  statusLabel: string
}

export function MatchStatus(props: Props) {
  const context = useCustomContext()
  const handleClick = () => {
    context?.sendGaEvent({ eventAction: 'click', eventLabel: props.matchData.resultLink })
  }
  return props.statusLabel === 'Plannlagt' ? (
    <div class={styles['dh-fotball-banner__match-status']}>
      <a href={props.matchData.resultLink} onClick={handleClick}>
        <time>{formatTime(props.matchData.timestamp)}</time>
        <div class={styles['dh-fotball-banner__match-status__tvchannel']}>
          {props.matchData.tvChannel}
        </div>
      </a>
    </div>
  ) : (
    <div class={styles['dh-fotball-banner__match-status']}>
      <a href={props.matchData.resultLink} onClick={handleClick}>
        <div
          class={
            props.statusLabel === 'Pågår' ? styles['dh-fotball-banner__match-status-ongoing'] : ''
          }
        >
          {props.statusLabel}
        </div>
        <div class={styles['dh-fotball-banner__match-status__tvchannel']}>
          {props.matchData.tvChannel}
        </div>
      </a>
    </div>
  )
}

function formatTime(matchDate) {
  if (!matchDate) {
    return matchDate
  }
  const date = new Date(matchDate)
  const minutes = `0${date.getMinutes()}`.slice(-2)
  return `${date.getHours()}:${minutes}`
}
